import { createClient } from 'contentful';

export const contentfulClient = createClient({
  space: '7axnvi0czuvv',
  accessToken: '7OCsBpCsY58zsLJ_h51EH1CCEUj9Ac4WG6KXNaDbxt0',
  environment: 'master',
}); 